import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import clsx from 'clsx';

import { ApiKeyContext } from 'contexts/ApiKeyContext';
import { InstantWinEvent } from 'models/instantWinEvent';
import { ReduxState } from 'ducks';
import { fetchInstantWinWithTierRemaining } from 'ducks/client/instantWin';
import { clearInstantWinEvents } from 'ducks/client/instantWinEvent';
import { InstantWinTierModal } from 'components/InstantWinTierModal/InstantWinTierModal';

import rouletteStyles from './Roulette.module.css';
import styles from './InstantWinLotteryModal.module.css';
import { DrawTypeRoulette } from './DrawTypeRoulette';

export const InstantWinLotteryModal = ({
  instantWinEvent,
  open,
  onClose,
}: {
  instantWinEvent: InstantWinEvent;
  open: boolean;
  onClose: () => void;
}) => {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const instantWinWithTierRemaining = useSelector(
    (state: ReduxState) => state.instantWin.instantWinWithTierRemaining
  );
  const { apiKey } = React.useContext(ApiKeyContext);
  const [tierKey, setTierKey] = React.useState<string>('');
  const [openTierModal, setOpenTierModal] = React.useState<boolean>(false);

  const instantWin = instantWinWithTierRemaining?.instant_win;

  React.useEffect(() => {
    if (instantWinEvent && instantWinEvent.instant_win_id) {
      dispatch(
        fetchInstantWinWithTierRemaining(apiKey, instantWinEvent.instant_win_id, i18n.language)
      );
    }
  }, [instantWinEvent]);

  if (!instantWin) {
    return null;
  }

  const keyVisual = instantWin?.page_design_contents?.thumbnail_url;
  const title = instantWin?.page_design_contents?.title || '';
  const description = instantWin?.page_design_contents?.description;

  return (
    <>
      <div className={clsx(styles['modal'], styles['--stamp'], open ? styles['is-active'] : null)}>
        <div className={clsx(styles['modal__inner'], styles['--stamp'])}>
          <div className={clsx(styles['modal__content'], styles['--stamp'])}>
            <div className={rouletteStyles.container}>
              <div className={rouletteStyles.card}>
                <div className={rouletteStyles.header} style={{ display: 'flex' }}>
                  <h1 className={rouletteStyles.title}>{title}</h1>
                </div>
                <div className={rouletteStyles.content}>
                  {description && <div className={rouletteStyles.banner}>{description}</div>}
                  <div className={rouletteStyles.gameSection}>
                    <div className={rouletteStyles.rouletteWrapper}>
                      <DrawTypeRoulette
                        instantWinEvent={instantWinEvent}
                        onTierKeyChange={setTierKey}
                        onTierModalOpen={() => setOpenTierModal(true)}
                      />
                    </div>
                  </div>
                </div>
                <div className={rouletteStyles.prizeSection}>
                  <img src={keyVisual} className={rouletteStyles.prizesImage} />
                  <div className={rouletteStyles.closeButton} onClick={() => onClose()}>
                    <img src="/static/images/instantwin_close.svg" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={clsx(styles['modal__overlay'], styles['--stamp'])}></div>
      </div>
      {openTierModal && (
        <InstantWinTierModal
          open={openTierModal}
          onClose={() => {
            setOpenTierModal(false);
            dispatch(clearInstantWinEvents());
          }}
          instantWin={instantWin}
          instantWinEvent={instantWinEvent}
          tierKey={tierKey}
        />
      )}
    </>
  );
};
